@if (data(); as data) {
  <form
    (ngSubmit)="handleSubmitClick()"
    [formGroup]="form"
    class="flex flex-col gap-6">
    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Zamówienie #{{ data.orderNumber }}</h5>

      <p-divider appPrimengDivider />

      <h5>Produkty</h5>

      <div
        [formArray]="form.controls.items"
        class="flex flex-col gap-4">
        @for (item of data.items; track item.id; let index = $index) {
          <div
            class="relative grid gap-4 rounded-sm border border-gray-100 bg-gray-50 p-6 md:grid-cols-[minmax(0,1fr)_14rem]">
            @if (data.items.length > 1) {
              <div
                class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
                {{ index + 1 }}.
              </div>
            }

            <div class="flex items-center gap-3">
              @if (item.featuredFile; as featuredFile) {
                <app-image-thumbnail size="md">
                  <img
                    [fill]="true"
                    [ngSrc]="featuredFile.url"
                    [alt]="featuredFile.alt" />
                </app-image-thumbnail>
              }

              <div class="flex flex-col gap-1">
                <div class="font-medium">{{ item.name }}</div>

                @if (item.subName; as subName) {
                  <div class="text-sm text-gray-500">{{ subName }}</div>
                }

                <div class="text-sm text-gray-500">
                  Ilość: {{ item.quantity }} | Cena pozycji:
                  <app-currency [amount]="item.price" />
                </div>

                <div class="text-sm text-gray-500">
                  Maksymalna kwota zwrotu:
                  <app-currency [amount]="itemMaxRefundAmount(index)" />
                </div>

                @if (isItemFullyRefunded(index)) {
                  <div class="text-sm font-bold text-green-600">
                    Pozycja została już w pełni zwrócona.
                  </div>
                }
              </div>
            </div>

            @if (!isItemFullyRefunded(index)) {
              <app-form-control label="Kwota zwrotu">
                <p-input-number
                  [disabled]="isItemFullyRefunded(index)"
                  [fluid]="true"
                  [formControl]="itemControls()[index].controls.amount"
                  [max]="itemMaxRefundAmount(index)"
                  [min]="0"
                  currency="PLN"
                  mode="currency"
                  placeholder="0,00" />
              </app-form-control>
            }
          </div>
        }
      </div>

      <p-divider appPrimengDivider />

      <h5>Przesyłki</h5>

      <div
        [formArray]="form.controls.shipments"
        class="flex flex-col gap-4">
        @for (
          shipment of data.shipments;
          track shipment.id;
          let index = $index
        ) {
          <div
            class="relative grid gap-4 rounded-sm border border-gray-100 bg-gray-50 p-6 md:grid-cols-[minmax(0,1fr)_14rem]">
            @if (data.shipments.length > 1) {
              <div
                class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
                {{ index + 1 }}.
              </div>
            }

            <div class="flex flex-col gap-1">
              <div class="font-medium">{{ shipment.methodName }}</div>

              <div class="text-sm text-gray-500">
                Cena przesyłki:
                <app-currency [amount]="shipment.price" />
              </div>

              <div class="text-sm text-gray-500">
                Maksymalna kwota zwrotu:
                <app-currency [amount]="shipmentMaxRefundAmount(index)" />
              </div>

              @if (isShipmentFullyRefunded(index)) {
                <div class="text- text-sm font-bold text-green-600">
                  Pozycja została już w pełni zwrócona.
                </div>
              }
            </div>

            @if (!isShipmentFullyRefunded(index)) {
              <app-form-control label="Kwota zwrotu">
                <p-input-number
                  [disabled]="isShipmentFullyRefunded(index)"
                  [fluid]="true"
                  [formControl]="shipmentControls()[index].controls.amount"
                  [max]="shipmentMaxRefundAmount(index)"
                  [min]="0"
                  currency="PLN"
                  mode="currency"
                  placeholder="0,00" />
              </app-form-control>
            }
          </div>
        }
      </div>

      <p-divider appPrimengDivider />

      <app-form-control label="Komentarz / uwagi">
        <textarea
          [formControl]="form.controls.comment"
          [maxlength]="commentMaxLength"
          appPrimengTextarea
          pTextarea
          rows="5"></textarea>
      </app-form-control>
    </div>

    <div class="flex justify-end gap-4">
      <p-button
        (onClick)="handleCancelClick()"
        appPrimengButton
        label="Anuluj"
        type="button"
        variant="outlined" />

      <p-button
        [disabled]="form.invalid || !hasRefundsToSubmit()"
        appPrimengButton
        label="Wykonaj częściowy zwrot"
        type="submit" />
    </div>
  </form>
} @else {
  <div class="flex min-h-80 items-center justify-center">
    <app-spinner-filled />
  </div>
}
